import React, { useState } from 'react';
import '../../../assets/css/Header.css';

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [bookingId, setBookingId] = useState('');

  const handleCheck = (e) => {
    e.preventDefault();
    if (bookingId.trim()) {
      window.location.href = `/booking/pending?bookingId=${bookingId.trim().toUpperCase()}`;
    }
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-center"></div>

          <div className="header-right">
            <button
              className="header-action-button"
              onClick={() => setShowModal(true)}
            >
              CHECK BOOKING
            </button>
          </div>
        </div>
      </header>

      {/* Check Booking Modal (Modern Capsule Redesign) */}
      {showModal && (
        <div className="booking-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowModal(false)} aria-label="Close">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            <div className="modal-header">
              <div className="modal-badge-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
              <h3>Check Booking Status</h3>
              <p>Masukkan Booking ID untuk melihat rincian pemesanan dan status pembayaran Anda.</p>
            </div>

            <form onSubmit={handleCheck} className="modal-capsule-form">
              <div className="modal-capsule-wrapper">
                <input
                  type="text"
                  placeholder="Ketik Booking ID (misal: BK17...)"
                  value={bookingId}
                  onChange={(e) => setBookingId(e.target.value)}
                  autoFocus
                />
                <button type="submit" className="modal-capsule-btn">
                  Cari
                </button>
              </div>
            </form>

            <div className="modal-footer-note">
              <span>Booking ID dapat ditemukan pada konfirmasi WhatsApp Anda.</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
